import { DataflowFloatTextFieldProps } from './DataflowFloatTextField.types'
import { ChangeEvent, useCallback } from 'react'

const useDataflowFloatTextField = (props: DataflowFloatTextFieldProps) => {
  const { onChange, ...rest } = props

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange && /^-?((\d+)?\.?(\d+)?)?$/.test(event.target.value)) {
        onChange(event)
      }
    },
    [onChange]
  )

  return {
    ...rest,
    handleChange
  }
}

export default useDataflowFloatTextField
